module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4b40b0a415a9776ae5413d1c6d7e63fc.png";